import axiosInstance from "./axiosInstance";

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};


export const scanPassportOCR = async (file: File) => {
  const formData = new FormData();
  formData.append("PassportImage", file);
  const res = await axiosInstance.post("/ocr/passport/scan", formData, {
    headers: {
      ...getAuthHeader(),
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};
